<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Categories</span>
              </b-col>
              <b-col cols="12" md="3" class="py-2">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  router-link
                  to="/Categories/Add"
                  >Add New Category</b-button
                >
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col
              v-for="(item, i) in categories"
              :key="i"
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="4"
            >
              <b-card style="max-width: 30rem">
                <b-row>
                  <b-col cols="12" md="4" class="text-center">
                    <b-img
                      :src="baseURL + '/r/' + item.Icon"
                      height="70px"
                    ></b-img>
                  </b-col>
                  <b-col cols="12" md="8">
                    <b-row>
                      <b-col cols="12">
                        <span class="item_title">
                          {{ item.Name }}
                        </span>
                      </b-col>
                      <b-col cols="12" class="item_value">
                        {{ item.Description.slice(0, 110) }}
                        <span v-if="item.Description.length > 110"
                          >&nbsp;...</span
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <template slot="footer">
                  <b-row class="justify-content-center">
                    <div class="px-2">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        :to="'/Categories/Edit/' + item.ID"
                      >
                        Edit
                      </b-button>
                    </div>
                    <div class="px-2">
                      <b-button
                        :disabled="item.Is_Delete"
                        variant="danger"
                        size="sm"
                        @click.prevent="confirmRemoveCategories(item)"
                      >
                        Remove Category
                      </b-button>
                    </div>
                  </b-row>
                </template>
              </b-card>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      categories: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/category",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categories = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmRemoveCategories(item) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to Remove this Banner.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.removeCategory(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    removeCategory(item) {
      this.appLoading = true;
      axios({
        method: "DELETE",
        url: "/category/" + item.ID,
        // data: {
        //   id: item.id,
        // },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Category Deleted Successfully",
              text: "",
              type: "success",
            });
            this.getData();
          } else {
            this.$notify({
              group: "appNotification",
              title: "Category Deleted Failed",
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
